import axios from "axios";

import queryString from "query-string";
import { attachJwtAuthInterceptors } from "./jwtAuthInterceptors";
import { applyCacheRequestBrand } from "./cacheRequestBrand";

const ftApiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL_V2,

    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },

    paramsSerializer: (params) => queryString.stringify(params),
});

ftApiClient.interceptors.request.use(applyCacheRequestBrand);

attachJwtAuthInterceptors(ftApiClient);

export default ftApiClient;
